export enum StockStatus {
  InStock,
  OutOfStock,
  OnDisplayToOrder,
}
